import React, { useState } from 'react';
import CustomerDropdown from './CustomerDropdown';
import TeamDropdown from './TeamDropdown';
import OrganizationsList from './OrganizationsList';
import { getAgenturenByOrganization } from '../../../api';

function HamburgerMenu({
  isOpen,
  onClose,
  activeSection,
  onSectionChange,
  onLogout,
  user,
  isAdmin,
  isTeamlead,
  isOrgLeader,
  isAgenturLeader,
  isCallcenterLeader,
  isCallcenterMitarbeiter,
  isFachberater,
  leadCounts,
  openSettingsPanel,
  handleCustomerFilter,
  handleTeamDashboard,
  handleViewOrganizationLeads,
  onOpenOrganizationManagement,
  onOpenMembersManagement,
  onViewTeamLeads,
  navigate
}) {
  const [expandedMenu, setExpandedMenu] = useState(null);
  // Agenturen Dropdown State
  const [agenturenDropdownOpen, setAgenturenDropdownOpen] = useState(false);
  const [agenturen, setAgenturen] = useState([]);
  const [agenturenLoading, setAgenturenLoading] = useState(false);
  const [selectedAgenturId, setSelectedAgenturId] = useState(null);
  const [agenturenFehler, setAgenturenFehler] = useState(null);

  // Agenturen laden, wenn Menü geöffnet und Orgleiter/Agenturleiter
  React.useEffect(() => {
    if ((isOrgLeader || isAgenturLeader) && agenturenDropdownOpen) {
      const loadAgenturen = async () => {
        setAgenturenLoading(true);
        setAgenturenFehler(null);
        try {
          if (isOrgLeader && user?.organization_id) {
            const res = await getAgenturenByOrganization(user.organization_id);
            if (res.success) {
              setAgenturen(res.agenturen || []);
            } else {
              setAgenturen([]);
              setAgenturenFehler('Fehler beim Laden der Agenturen');
            }
          } else if (isAgenturLeader && user?.agentur_id) {
            const res = await getAgenturenByOrganization(user.organization_id);
            if (res.success) {
              const eigeneAgentur = (res.agenturen || []).filter(a => String(a.id) === String(user.agentur_id));
              console.log("eigeneAgentur : ", eigeneAgentur);
              setAgenturen(eigeneAgentur);
            } else {
              setAgenturen([]);
              setAgenturenFehler('Fehler beim Laden der Agenturen');
            }
          }
        } catch (e) {
          setAgenturen([]);
          setAgenturenFehler('Fehler beim Laden der Agenturen');
        } finally {
          setAgenturenLoading(false);
        }
      };
      loadAgenturen();
    }
  }, [isOrgLeader, isAgenturLeader, user?.organization_id, user?.agentur_id, agenturenDropdownOpen]);

  const menuStyles = {
    position: 'fixed',
    top: 0,
    left: isOpen ? 0 : '-300px',
    width: '280px',
    height: '100vh',
    backgroundColor: 'white',
    boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    transition: 'left 0.3s ease-in-out',
    overflowY: 'auto',
    paddingTop: '60px'
  };

  const headerStyles = {
    padding: '20px',
    borderBottom: '1px solid #e2e8f0',
    backgroundColor: '#f8fafc'
  };

  const userInfoStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  };

  const avatarStyles = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4a6de5, #667eea)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: '600'
  };

  const userNameStyles = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#2d3748',
    marginBottom: '4px'
  };

  const userRoleStyles = {
    fontSize: '12px',
    color: '#718096'
  };

  const menuItemStyles = {
    display: 'block',
    width: '100%',
    padding: '16px 20px',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#4a5568',
    transition: 'background-color 0.2s',
    borderBottom: '1px solid #f7fafc'
  };

  const activeMenuItemStyles = {
    ...menuItemStyles,
    backgroundColor: '#ebf4ff',
    color: '#4a6de5',
    fontWeight: '600'
  };

  const expandableMenuStyles = {
    borderBottom: '1px solid #f7fafc'
  };

  const submenuStyles = {
    backgroundColor: '#f8fafc',
    borderTop: '1px solid #e2e8f0'
  };

  const submenuItemStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '12px 40px',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#4a5568',
    transition: 'background-color 0.2s'
  };

  const logoutButtonStyles = {
    ...menuItemStyles,
    color: '#e53e3e',
    fontWeight: '600',
    marginTop: '20px',
    borderTop: '1px solid #e2e8f0'
  };

  const getUserInitials = () => {
    const name = user?.full_name || user?.email || 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  };

  const getUserRoles = () => {
    console.log("isAgenturLeader : ", isAgenturLeader);
    const roles = [];
    if (isAdmin) roles.push('Admin');
    if (isOrgLeader) roles.push('Orgleiter');
    if (isTeamlead) roles.push('Teamleiter');
    if (isCallcenterLeader) roles.push('Callcenter-Leiter');
    if (isCallcenterMitarbeiter) roles.push('Callcenter');
    if (isFachberater) roles.push('Fachberater');
    if (isAgenturLeader) roles.push('Agenturleiter');
    return roles.join(', ') || 'Benutzer';
  };

  const handleMenuClick = (section, data = null) => {
    if (data) {
      onSectionChange(section, data);
    } else {
      onSectionChange(section);
    }
    onClose();
  };

  const handleRouteNavigation = (route) => {
    navigate(route);
    onClose();
  };

  const handleExpandableMenu = (menuName) => {
    setExpandedMenu(expandedMenu === menuName ? null : menuName);
  };

  // Nur für Callcenter Leader (nicht für Fachberater)
  const showCustomerDropdown = isCallcenterLeader && !isFachberater;

  return (
    <div style={menuStyles}>
      {/* User Header */}
      <div style={headerStyles}>
        <div style={userInfoStyles}>
          <div style={avatarStyles}>
            {getUserInitials()}
          </div>
          <div>
            <div style={userNameStyles}>
              {user?.full_name || user?.email || 'Benutzer'}
            </div>
            <div style={userRoleStyles}>
              {getUserRoles()}
            </div>
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div style={{ padding: '0' }}>

        {/* Dashboard */}
        <button
          style={activeSection === 'dashboard' ? activeMenuItemStyles : menuItemStyles}
          onClick={() => handleRouteNavigation('/dashboard')}
        >
          🏠 Dashboard
        </button>

        {/* Für Fachberater: Termine und Bewertungen anzeigen */}
        {isFachberater ? (
          <>
            <button
              style={menuItemStyles}
              onClick={() => handleRouteNavigation('/termine')}
            >
              📅 Termine
            </button>
            <button
              style={menuItemStyles}
              onClick={() => handleRouteNavigation('/my-bewertungen')}
            >
              ⭐ Alle Bewertungen
            </button>
          </>
        ) : (
          <>
            {/* Kunden mit Dropdown nur für Callcenter Leader */}
            {showCustomerDropdown ? (
              <div style={expandableMenuStyles}>
                <button
                  style={{
                    ...menuItemStyles,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                  onClick={() => handleExpandableMenu('customers')}
                >
                  <span>👥 Kunden</span>
                  <span style={{
                    transform: expandedMenu === 'customers' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>

                {expandedMenu === 'customers' && (
                  <div style={submenuStyles}>
                    <CustomerDropdown
                      leadCounts={leadCounts}
                      handleCustomerFilter={handleCustomerFilter}
                      isCallcenterLeader={isCallcenterLeader}
                      isCallcenterMitarbeiter={isCallcenterMitarbeiter}
                      navigate={navigate}
                      onClose={onClose}
                      submenuItemStyles={submenuItemStyles}
                    />
                  </div>
                )}
              </div>
            ) : isCallcenterMitarbeiter ? (
              // Callcenter Mitarbeiter haben einfachen Kunden-Button
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/leads-normal')}
              >
                👥 Kunden
              </button>
            ) : (
              // Normale Benutzer und OrgLeader haben einfachen Kunden-Button
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/leads-normal')}
              >
                👥 Kunden
              </button>
            )}

            {/* Leads für Nicht-Callcenter und OrgLeader */}
            {!isCallcenterLeader && !isCallcenterMitarbeiter && (
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/leads')}
              >
                📊 Leads
              </button>
            )}

            {/* Termine für Callcenter Leader */}
            {console.log(isCallcenterLeader, isOrgLeader)}

            {isCallcenterLeader || isOrgLeader && (
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/termine')}
              >
                📅 Termine
              </button>
            )}

            {/* Bestellverwaltung - Nur für Organisationsleiter */}
            {isOrgLeader && (
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/orders-management')}
              >
                Bestellverwaltung
              </button>
            )}

            {/* Agenturen Dropdown für Orgleiter und Agenturleiter */}
            {(isOrgLeader || isAgenturLeader) && (
              <div style={expandableMenuStyles}>
                <button
                  style={{
                    ...menuItemStyles,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                  onClick={e => {
                    // Verhindere, dass das Overlay das Menü schließt
                    e.stopPropagation();
                    setAgenturenDropdownOpen(!agenturenDropdownOpen);
                    setSelectedAgenturId(null);
                  }}
                >
                  <span>🏢 Agenturen verwalten</span>
                  <span style={{
                    transform: agenturenDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {agenturenDropdownOpen && (
                  <div style={submenuStyles} onClick={e => e.stopPropagation()}>
                    {agenturenFehler ? (
                      <div style={{ padding: '8px 16px', color: 'red' }}>{agenturenFehler}</div>
                    ) : agenturenLoading ? (
                      <div style={{ padding: '8px 16px', color: '#666' }}>Lade Agenturen...</div>
                    ) : agenturen.length === 0 ? (
                      <div style={{ padding: '8px 16px', color: '#666' }}>Keine Agenturen verfügbar</div>
                    ) : (
                      agenturen.map(ag => (
                        <div key={ag.id} style={{ position: 'relative' }}>
                          <button
                            style={submenuItemStyles}
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedAgenturId(selectedAgenturId === ag.id ? null : ag.id);
                            }}
                          >
                            {ag.name}
                            <span style={{ float: 'right', marginLeft: 8 }}>▶</span>
                          </button>
                          {/* Untermenü für die ausgewählte Agentur */}
                          {selectedAgenturId === ag.id && (
                            <div style={{
                              ...submenuStyles,
                              position: 'relative',
                              left: 0,
                              top: 0,
                              minWidth: '180px',
                              zIndex: 1100
                            }} onClick={e => e.stopPropagation()}>
                              <button
                                style={submenuItemStyles}
                                onClick={() => {
                                  handleRouteNavigation(`/agentur-dashboard/${ag.id}`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                📊 Dashboard anzeigen
                              </button>
                              <button
                                style={submenuItemStyles}
                                onClick={() => {
                                  handleRouteNavigation(`/agenturen/${ag.id}/mitglieder`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                👥 Mitglieder verwalten
                              </button>
                              <button
                                style={submenuItemStyles}
                                onClick={() => {
                                  handleRouteNavigation(`/agenturen/${ag.id}/leads`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                📋 Alle Leads
                              </button>
                              <button
                                style={submenuItemStyles}
                                onClick={() => {
                                  handleRouteNavigation(`/agenturen/${ag.id}/teams`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                👨‍👩‍👧‍👦 Meine Teams
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Team Menu für Teamleiter in einer Agentur: Nur eigenes Team, Links wie bei Orgleiter */}
            {isTeamlead && user?.a_team_id && (
              <div style={expandableMenuStyles}>
                <button
                  style={{
                    ...menuItemStyles,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                  onClick={() => handleExpandableMenu('team')}
                >
                  <span>👥 Team</span>
                  <span style={{
                    transform: expandedMenu === 'team' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {expandedMenu === 'team' && (
                  <div style={submenuStyles}>
                    <button
                      style={submenuItemStyles}
                      onClick={() => handleRouteNavigation(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/dashboard`)}
                    >
                      📊 Team Dashboard
                    </button>
                    <button
                      style={submenuItemStyles}
                      onClick={() => handleRouteNavigation(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/mitarbeiter`)}
                    >
                      👥 Mitglieder ansehen
                    </button>
                    <button
                      style={submenuItemStyles}
                      onClick={() => handleRouteNavigation(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/leads`)}
                    >
                      📋 Team-Leads ansehen
                    </button>
                  </div>
                )}
              </div>
            )}
            {/* Standard Team Menu für andere Teamleiter (ohne My-Team Routen) */}
            {isTeamlead && !user?.a_team_id && (
              <div style={expandableMenuStyles}>
                <button
                  style={{
                    ...menuItemStyles,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                  onClick={() => handleExpandableMenu('team')}
                >
                  <span>👥 Team</span>
                  <span style={{
                    transform: expandedMenu === 'team' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {expandedMenu === 'team' && (
                  <div style={submenuStyles}>
                    <button
                      style={submenuItemStyles}
                      onClick={() => handleRouteNavigation('/organization-management')}
                    >
                      👥 Team verwalten
                    </button>
                    <button
                      style={submenuItemStyles}
                      onClick={() => {
                        if (user?.team?.id) {
                          navigate(`/create-user?teamId=${user.team.id}`);
                        } else {
                          navigate('/create-user');
                        }
                        onClose();
                      }}
                    >
                      ➕ Mitarbeiter hinzufügen
                    </button>
                    <button
                      style={submenuItemStyles}
                      onClick={() => {
                        if (user?.team?.id) {
                          navigate(`/team-leads/${user.team.id}?name=${encodeURIComponent(user.team.name || 'Mein Team')}`);
                        } else {
                          alert('Kein Team gefunden. Bitte kontaktieren Sie den Administrator.');
                        }
                        onClose();
                      }}
                    >
                      📋 Team-Leads ansehen
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Mein Team entfernt */}

            {/* Organisationen Menu für Orgleiter, Teamleiter und Admin */}
            {(isOrgLeader || isTeamlead || isAdmin) && (
              <div style={expandableMenuStyles}>
                <button
                  style={{
                    ...menuItemStyles,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                  onClick={() => handleExpandableMenu('organization')}
                >
                  <span>🏢 Organisationen</span>
                  <span style={{
                    transform: expandedMenu === 'organization' ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>

                {expandedMenu === 'organization' && (
                  <div style={submenuStyles}>
                    <OrganizationsList
                      user={user}
                      navigate={navigate}
                      onClose={onClose}
                      submenuItemStyles={submenuItemStyles}
                      onOpenOrganizationManagement={onOpenOrganizationManagement}
                      onOpenMembersManagement={onOpenMembersManagement}
                      onViewOrganizationLeads={handleViewOrganizationLeads}
                      isInHamburgerMenu={true}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Bestellungen - Nur für Agenturleiter */}
            {isAgenturLeader && (
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/orders')}
              >
                🛒 Bestellungen
              </button>
            )}

            {/* Stellungnahmen - Nicht für Fachberater und nicht für Agenturleiter */}
            {(!isFachberater && !isAgenturLeader) && (
              <button
                style={menuItemStyles}
                onClick={() => handleRouteNavigation('/stellungnahmen')}
              >
                📝 Stellungnahmen
              </button>
            )}
          </>
        )}

        {/* Einstellungen - Für alle Rollen */}
        <button
          style={menuItemStyles}
          onClick={() => {
            openSettingsPanel();
            onClose();
          }}
        >
          ⚙️ Einstellungen
        </button>

        {/* Logout */}
        <button
          style={logoutButtonStyles}
          onClick={() => {
            onLogout();
            onClose();
          }}
        >
          🚪 Ausloggen
        </button>
      </div>
    </div>
  );
}

export default HamburgerMenu;